import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { generalWhatsapp } from "@/lib/whatsapp";

export default function FloatingWhatsApp({ message }) {
  const [hover, setHover] = useState(false);
  const link = message || generalWhatsapp();
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Chat with BIOSYN on WhatsApp"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="fixed bottom-5 right-5 z-50 flex items-center gap-2.5 rounded-full text-white shadow-lg transition-transform duration-300 hover:scale-105"
      style={{ background: "#25D366", padding: hover ? "0.85rem 1.25rem" : "0.9rem", boxShadow: "0 8px 24px rgba(37,211,102,0.4)" }}
    >
      <MessageCircle className="w-6 h-6 shrink-0" />
      <span className={`overflow-hidden whitespace-nowrap font-semibold text-sm transition-all duration-300 ${hover ? "max-w-[180px] opacity-100" : "max-w-0 opacity-0"}`}>
        Chat with us
      </span>
    </a>
  );
}
